import type { SceneBuilder } from "../../reel/scenes.js";
import { brandBackdrop } from "../../primitives/brandBackdrop.js";
import {
  accentFor, clipFrame, clipOutroFade, combineSceneFragments, makeTl, typeSize, weights, withAlpha,
  colors as themeColors, escapeHtml,
} from "../../reel/sceneShared.js";

export const gradientReveal: SceneBuilder = ({ ctx, clipPrefix, inputs, clipDurationSec, clipStartSec }) => {
  const text = inputs.text ?? "";
  const accent = accentFor(inputs);
  const hero = typeSize("hero", ctx.format);
  const t = makeTl(clipStartSec);
  const revealId = `${clipPrefix}-rev`;
  const ghostId = `${clipPrefix}-ghost`;
  const maxW = ctx.format === "9:16" ? 940 : 1500;

  const backdrop = brandBackdrop(ctx, `${clipPrefix}-bg`, { variant: "grid", accent });

  const inner = `<div style="position:relative;max-width:${maxW}px;">
  <h1 id="${ghostId}" style="margin:0;font-family:'Outfit',sans-serif;font-weight:${weights.black};font-size:${hero}px;line-height:.95;letter-spacing:-3.5px;color:${withAlpha(themeColors.fg, 0.18)};text-align:center;text-wrap:balance;">${escapeHtml(text)}</h1>
  <h1 id="${revealId}" aria-hidden="true" style="position:absolute;inset:0;margin:0;font-family:'Outfit',sans-serif;font-weight:${weights.black};font-size:${hero}px;line-height:.95;letter-spacing:-3.5px;background-image:linear-gradient(90deg, ${accent}, ${themeColors.fg});-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent;color:transparent;text-align:center;text-wrap:balance;clip-path:inset(0 100% 0 0);">${escapeHtml(text)}</h1>
</div>`;

  const html = clipFrame({ clipPrefix, clipStartSec, clipDurationSec, inner });

  const tweens = [
    `tl.to({v:100},{v:0,duration:1.0,ease:"power3.out",onUpdate:function(){var v=this.targets()[0].v;var el=document.getElementById(${JSON.stringify(revealId)});if(el)el.style.clipPath="inset(0 "+v+"% 0 0)";}},${clipStartSec.toFixed(4)});`,
    clipOutroFade(clipPrefix, clipDurationSec, clipStartSec),
  ];

  return combineSceneFragments([backdrop, { html, tweens }]);
};
